
import DefaultTranslation from '../translations/DefaultTranslation';
import Equipotel2025Translation from '../translations/Equipotel2025Translation';
import ProductsTranslation from '../translations/ProductsTranslation';
import ServicesTranslation from '../translations/ServicesTranslation';
import TestimonialsTranslation from '../translations/TestimonialsTranslation';
import WebsiteTranslation from '../translations/WebsiteTranslation';


const allTranslations = {
    ...DefaultTranslation,
    ...WebsiteTranslation,
    ...ProductsTranslation,
    ...ServicesTranslation,
    ...TestimonialsTranslation,
    ...Equipotel2025Translation
};

const FindTranslation = (key) => {
    if (allTranslations[key]) {
        return allTranslations[key];
    }
    
    console.warn(`Translation not found: ${key}`);
    return undefined;
}


const LanguageHelper = {
    FindTranslation
}


export default LanguageHelper;